// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';

import { ActionResponse, StandardThunkAction } from '../../types';

// Action types
export const LOAD_ACTION_SUCCESS = Symbol('loaders/LOAD_ACTION_SUCCESS');
export const LOAD_ACTION_ERROR = Symbol('loaders/LOAD_ACTION_ERROR');

export type LoadActionSuccessAction = Action<
  typeof LOAD_ACTION_SUCCESS,
  ActionResponse
>;
export type LoadActionErrorAction = Action<typeof LOAD_ACTION_ERROR, Error>;

// Action creators
const loadActionSuccess = actionCreator<LoadActionSuccessAction>(
  LOAD_ACTION_SUCCESS,
);
const loadActionError = actionCreator<LoadActionErrorAction>(LOAD_ACTION_ERROR);

export const loadAction = (idAction: string): StandardThunkAction => {
  return async (dispatch) => {
    try {
      const action = await API.client.rest.get<ActionResponse>(
        `actions/${idAction}`,
        {
          query: {
            display: true,
            memberCreator: true,
          },
        },
      );

      dispatch(loadActionSuccess(action));
    } catch (err) {
      dispatch(loadActionError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-actions.ts